import React from "react";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import FormError from "../formError/FormError";

const ClientFormShops = ({
  client,
  onChange,
  allow,
  translate,
  form,
  readOnly,
}) => {
  if (!IsAllow(allow, "customer-02")) return null;

  return (
    <div>
      <label className="label">{translate("shops-amount")}</label>
      <input
        type="number"
        name="shops"
        value={client.shops}
        onChange={onChange}
        className="input"
        disabled={readOnly}
      />
      <FormError form={form} name="shops" />
    </div>
  );
};

export default ClientFormShops;
